define('rsm_autopay_creditcardvalidation.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('rsm_autopay_creditcardvalidation', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/RSM/AppliedSystemsMain/1.0.0/', 'extensions/RSM/AppliedSystemsMain/1.0.0/', Handlebars);
});